
import * as api from "../constant/NewAPI";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Utils from "../constant/Utils";
import Swal from "sweetalert2";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";

// import * as api from "../constant/API";

const AcademicAssessment = () => {

    const roleId = localStorage.getItem("RoleId");

    const [searchInput, setSearchInput] = useState("");
    const [assessmentList, setAssessmentList] = useState([]);
    const [assessmentType, setAssessmentType] = useState("");
    const [assessmentDescription, setAssessmentDescription] = useState("");
    const [assessmentId, setAssessmentId] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false)

    const formRef = useRef(null);

    // if (roleId === "1") {
    useEffect(() => {
        asesmntList()
    }, [])
    // }

    function asesmntList() {
        const getAssessmentList = api.adminAssessmentList;
        fetch(getAssessmentList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                // console.log(result.data)
                setAssessmentList(result.data);
            })
            .catch((error) => {
                console.log("Failed to fetch grade list", error);
            })
    }

    const filteredData = assessmentList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value.toString().toLowerCase()
        );
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editGrade(rowData)}>
                <i className="feather-edit" />
                Edit
            </Link>
        );
    };

    const slNoRender = (rowData) => {
        return <span>{rowData.assessmentTypeId}</span>;
    };

    const nameRender = (rowData) => {
        return <span>{rowData.assessmentType}</span>;
    };

    const descriptionRender = (rowData) => {
        return <span>{rowData.assessmentTypeDescription}</span>
    }

    function editGrade(selectedRow) {
        const assessmentId = selectedRow.assessmentTypeId;
        const getAssessmentDetails = api.adminAssessmentData + '/' + assessmentId// "?assessmentTypeId=" + assessmentId;
        fetch(getAssessmentDetails, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((assessmentResponse) => assessmentResponse.json())
            .then((assessmentResult) => {
                // const dta = assessmentResult.data[0];
                const dta = assessmentResult.data;
                setAssessmentId(dta.assessmentTypeId)
                setAssessmentType(dta.assessmentType)
                setAssessmentDescription(dta.assessmentTypeDescription)
                setIsEdit(true)
                setOpenModal(true)
            })
            .catch((error) => {
                console.log("Failed to fetch selected row details.", error);
            })

    }

    function newAssessment() {
        setOpenModal(true);
        setIsEdit(false);
        setAssessmentType("");
        setAssessmentDescription("");
    }

    function addAssessment(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateAssessment()
            } else {
                const formData = new FormData();
                formData.append('assessmentType', assessmentType);
                formData.append('assessmentTypeDescription', assessmentDescription);

                const assessmentAdd = api.adminAssessmentCreate;
                fetch(assessmentAdd, {
                    method: "POST",
                    headers: {
                        "Authorization": 'Bearer ' + Utils.getAccessToken()
                    },
                    body: formData
                })
                    .then((response) => response.json())
                    .then((result) => {
                        if (result.error == false) {
                            Swal.fire({
                                title: 'Success',
                                text: result.message,
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        } else {
                            Swal.fire({
                                title: 'Error',
                                text: result.message,
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        }
                    })
            }
        }
        // setOpenModal(false)
    }

    function updateAssessment() {
        const formData = new FormData();
        formData.append('assessmentTypeId', assessmentId);
        formData.append('assessmentType', assessmentType);
        formData.append('assessmentTypeDescription', assessmentDescription);

        const assessmentUpdate = api.adminAssessmentUpdate;
        fetch(assessmentUpdate, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((updateResponse) => updateResponse.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
            .catch((error) => {
                console.log("Failed to update the schedule", error)
            })
    }

    return (
        <>
            <div className="row">
                <div className="col-sm-12">
                    <div className="court-tab-content">
                        <div className="card card-tableset">
                            <div className="card-body">
                                <div className="coache-head-blk">
                                    <div className="row align-items-center">
                                        {roleId == 1 ? (
                                            <>
                                                <div className="row col-lg-12">
                                                    <div className="col-lg-4">
                                                        <Link
                                                            to="#"
                                                            className="btn btn-secondary"
                                                            onClick={newAssessment}>
                                                            <i className="feather-plus" />&nbsp;
                                                            Add Assessment
                                                        </Link>
                                                    </div>
                                                </div>
                                            </>
                                        ) : null}
                                        <div className="col-md-6">
                                        </div>
                                        <div className="col-md-6">
                                            <div className="dataTables_filter">
                                                <label>
                                                    <input
                                                        type="text"
                                                        value={searchInput}
                                                        onChange={(e) => setSearchInput(e.target.value)}
                                                        placeholder="Search"
                                                        className="form-control"
                                                    />
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-content">
                                    <div
                                        className="tab-pane fade show active"
                                        id="nav-Recent"
                                        role="tabpanel"
                                        aria-labelledby="nav-Recent-tab"
                                        tabIndex={0}
                                    >
                                        <div className="table-responsive table-datatble">
                                            <DataTable
                                                className="table datatable"
                                                value={filteredData}
                                                paginator
                                                rows={10}
                                                rowsPerPageOptions={[10, 25, 50]}
                                                currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            >
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="assessmentTypeId"
                                                    body={slNoRender}
                                                    header="Sl No"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="assessmentType"
                                                    body={nameRender}
                                                    header="Assessment Type"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="assessmentTypeDescription"
                                                    body={descriptionRender}
                                                    header="Assessment Type Description"
                                                ></Column>
                                                <Column
                                                    body={editDetails}
                                                ></Column>
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Add/ Edit Assessment */}
            <Modal
                show={openModal}
                size="md"
                centered
            >
                <ModalHeader>
                    <ModalTitle>
                        <h4 className="mb-0 upper-case"><i className="feather-plus" />{isEdit ? "Edit " : "Add "}Assessment</h4>
                    </ModalTitle>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => setOpenModal(false)}
                    ></Button>
                </ModalHeader>
                <ModalBody>
                    <form ref={formRef}>
                        <div className="col-lg-12">
                            <div className="input-space">
                                <label className="form-label">Assessment Type</label>
                                <input
                                    id="assessmentType"
                                    className="form-control"
                                    style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                                    value={assessmentType}
                                    required
                                    onChange={(e) => {
                                        setAssessmentType(e.target.value)
                                    }}
                                />
                            </div>
                        </div>
                        <div className="col-lg-12">
                            <div className="input-space">
                                <label className="form-label">Assessment Description</label>
                                <textarea
                                    id="assessmentDescription"
                                    className="form-control"
                                    style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                                    value={assessmentDescription}
                                    required
                                    onChange={(e) => {
                                        setAssessmentDescription(e.target.value)
                                    }}
                                />
                            </div>
                        </div>
                        <ModalFooter>
                            <Button
                                className="btn-primary text-uppercase"
                                variant="success"
                                type="submit"
                                onClick={addAssessment}
                            // data-bs-dismiss="modal" aria-label="Close"
                            >
                                <b><i className="fas fa-save" />{isEdit ? "Update" : "Save"}</b>
                            </Button>
                        </ModalFooter>
                    </form>
                </ModalBody>
            </Modal>
            {/* /Add/ Edit Assessment */}
        </>
    );
};

export default AcademicAssessment;